/* eslint-disable max-len */
import React from 'react';

import LockedPage from 'components/LockedPage/LockedPage';

import { useStore } from 'utils/hooks/store';

import AuditImage from './images/auditsLockImage.png';
import ProtectorLockImage from './images/protectorLockImage.png';
import IncidentsImage from './images/incidentsLockImage.png';
import SitesLockImage from './images/sitesLockImage.png';
import ContactsLockImage from './images/contactsLockImage.png';
import AssetsLockImage from './images/assetsLockImage.png';
import DocumentsLockImage from './images/documentsLockImage.png';

import { FeaturesInformationType } from './types';

const FeaturesInformation: FeaturesInformationType = {
  audits: {
    name: 'Audits',
    infoTitle: 'audits & inspections',
    infoText:
      'Users of the Audits module can create custom audit and inspection forms, conduct inspections through our handy mobile app and track corrective actions.',
    image: AuditImage,
  },
  protector: {
    name: 'Lone Working',
    infoTitle: 'Lone Working Safety',
    infoText:
      'Users of the Lone Working module gain access to our lone working safety solutions. This module is designed to safeguard your staff and boost H&S compliance through our 24/7 monitored safety app or lone worker devices through our Lone Working Device and Lone Working Mobile App',
    image: ProtectorLockImage,
  },
  events: {
    name: 'Events',
    infoTitle: 'Event Reporting & Management',
    infoText:
      'Optimise your Event reporting and management processes with our customisable mobile and web-based solution. You can use this module for Event reporting, investigation, and tracking follow-up actions, all in one place.',
    image: IncidentsImage,
  },
  sites: {
    name: 'Sites',
    infoTitle: 'Sites',
    infoText:
      'The Sites module centralises site-specific data, streamlines activity management, and links records — such as events, audits, and assets — to individual locations for complete visibility.',
    image: SitesLockImage,
  },
  contacts: {
    name: 'Contacts',
    infoTitle: 'Contacts',
    infoText:
      'Manage all key contact details in one centralised place for clear oversight and easy access. Relate contacts with other modules to enhance visibility, coordination, and overall operational efficiency.',
    image: ContactsLockImage,
  },
  assets: {
    name: 'Assets',
    infoTitle: 'Assets',
    infoText:
      'Optimise how you manage and track workplace equipment with the Assets module. Record, monitor, and maintain your assets from one place to improve safety, compliance, and operational efficiency.',
    image: AssetsLockImage,
  },
  documents: {
    name: 'Documents',
    infoTitle: 'Documents',
    infoText:
      'Gain access to our AI-powered document management system. Create, edit, store, and manage all your documents securely in one centralised platform.',
    image: DocumentsLockImage,
  },
} as const;

const DisableFeatures: React.FunctionComponent = (): React.ReactElement => {
  const { routing } = useStore();
  const currentPage = routing.location.pathname.slice(17, -1);

  if (!FeaturesInformation[currentPage]) {
    return <LockedPage pageName="Unknown" infoTitle="Unknown" infoText="" image={ProtectorLockImage} />;
  }

  const { name, infoText, infoTitle, image } = FeaturesInformation[currentPage];

  return <LockedPage pageName={name} infoTitle={infoTitle} infoText={infoText} image={image} />;
};

export default DisableFeatures;
